"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFloat = void 0;
const isFloat_1 = require("./isFloat");
function toFloat(str) {
    if (!(0, isFloat_1.isFloat)(str)) {
        return NaN;
    }
    return parseFloat(str);
}
exports.toFloat = toFloat;
